module.exports = "/images/vendor/flag-icon-css/flags/4x3/ki.svg?db7e40f60e21ad4b6b6465409ce745b3";